import { render, staticRenderFns } from "./BuyerFormModal.vue?vue&type=template&id=6df361c6"
import script from "./BuyerFormModal.ts?vue&type=script&lang=ts&external"
export * from "./BuyerFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df361c6')) {
      api.createRecord('6df361c6', component.options)
    } else {
      api.reload('6df361c6', component.options)
    }
    module.hot.accept("./BuyerFormModal.vue?vue&type=template&id=6df361c6", function () {
      api.rerender('6df361c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/BuyerFormModal.vue"
export default component.exports